<template>
  <div>
    <gridTable
      style="padding: 12px 0"
      :columns="baseInfoColumns"
      :data-list="info.baseDataList"
    ></gridTable>
    <div v-for="(item, index) in otherInfo" :key="index">
      <gridTable
        style="padding-bottom: 12px"
        :columns="otherInfoColumns"
        :data-list="item.otherDataList"
      ></gridTable>
      <gridTable
        style="padding-bottom: 12px"
        :columns="[...item.otherInfoColumns2, ...totalColums]"
        :data-list="item.otherDataList2"
      ></gridTable>
      <gridTable
        v-show="index == otherInfo.length - 1"
        style="padding-bottom: 12px; width: 380px"
        :columns="item.totalColumnsList"
        :data-list="item.totalDataList"
      ></gridTable>
    </div>
  </div>
</template>

<script>
import gridTable from "./common/grid-table";

const activeBGColor = {
  // background: 'rgba(255,255,128,.5) !important',
};
export default {
  name: "print-content",
  components: {
    gridTable,
  },
  props: {
    info: {
      type: Object,
      default: () => {},
    },
    otherInfo: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      totalColums: [
        {
          label: "Total",
          property: "totalQuantity",
        },
      ],
      baseInfoColumns: [
        {
          label: "SUPPLIER 供应商",
          property: "vendorCode",
          style: activeBGColor,
        },
        {
          label: "ORDER NO 订单号",
          property: "sapPoNo",
          style: activeBGColor,
        },
        {
          label: "YEAR-SEASON 年-季度",
          property: "fixedText",
          style: activeBGColor,
        },
        {
          label: "COO 原产地",
          property: "sourceArea",
          style: activeBGColor,
        },
        {
          label: "Destination 目的地",
          property: "poArea",
          style: activeBGColor,
        },
      ],
      otherInfoColumns: [
        {
          label: "Order date 下单日期",
          property: "createdDate",
          style: activeBGColor,
        },
        {
          label: "Item",
          property: "poItemCode",
          style: activeBGColor,
        },
        {
          label: "Colour 颜色",
          property: "colorDescEn",
          style: activeBGColor,
        },
        {
          label: "Description 产品内容",
          property: "description",
          style: activeBGColor,
        },
        {
          label: "DEL 波段",
          property: "waveCode",
          style: activeBGColor,
        },
        {
          label: "Delivery Required 交货期",
          property: "deliveryDate",
          style: activeBGColor,
        },
        {
          label: "Currency 币种",
          property: "currency",
          style: activeBGColor,
        },
        {
          label: "Unit Price 单价",
          property: "price",
          style: activeBGColor,
        },
      ],

      totalInfoColumns: [
        {
          label: "FINAL TOTAL",
          property: "",
        },
        {
          label: "108",
          property: "",
        },
        {
          label: "3132.00",
          property: "",
        },
      ],
    };
  },
  computed: {},
};
</script>

<style scoped lang="scss">
</style>